import { render, staticRenderFns } from "./SidebarLinks.vue?vue&type=template&id=0e41eca4"
import script from "./SidebarLinks.vue?vue&type=script&lang=js"
export * from "./SidebarLinks.vue?vue&type=script&lang=js"
import style0 from "./SidebarLinks.vue?vue&type=style&index=0&id=0e41eca4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports